/* tslint:disable */
/* eslint-disable */
/**
 * Inhouse API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PaymentProvider } from './PaymentProvider';
import {
    PaymentProviderFromJSON,
    PaymentProviderFromJSONTyped,
    PaymentProviderToJSON,
    PaymentProviderToJSONTyped,
} from './PaymentProvider';
import type { PaymentMethodCategory } from './PaymentMethodCategory';
import {
    PaymentMethodCategoryFromJSON,
    PaymentMethodCategoryFromJSONTyped,
    PaymentMethodCategoryToJSON,
    PaymentMethodCategoryToJSONTyped,
} from './PaymentMethodCategory';
import type { PaymentMethodConfiguration } from './PaymentMethodConfiguration';
import {
    PaymentMethodConfigurationFromJSON,
    PaymentMethodConfigurationFromJSONTyped,
    PaymentMethodConfigurationToJSON,
    PaymentMethodConfigurationToJSONTyped,
} from './PaymentMethodConfiguration';
import type { PayoutSource } from './PayoutSource';
import {
    PayoutSourceFromJSON,
    PayoutSourceFromJSONTyped,
    PayoutSourceToJSON,
    PayoutSourceToJSONTyped,
} from './PayoutSource';

/**
 * 
 * @export
 * @interface CreatePaymentMethodRequest
 */
export interface CreatePaymentMethodRequest {
    /**
     * 
     * @type {PaymentMethodConfiguration}
     * @memberof CreatePaymentMethodRequest
     */
    _configuration: PaymentMethodConfiguration;
    /**
     * 
     * @type {string}
     * @memberof CreatePaymentMethodRequest
     */
    paymentMethod: string;
    /**
     * 
     * @type {PaymentMethodCategory}
     * @memberof CreatePaymentMethodRequest
     */
    paymentMethodCategory: PaymentMethodCategory;
    /**
     * 
     * @type {PaymentProvider}
     * @memberof CreatePaymentMethodRequest
     */
    paymentProvider: PaymentProvider;
    /**
     * 
     * @type {PayoutSource}
     * @memberof CreatePaymentMethodRequest
     */
    payoutSource: PayoutSource;
}



/**
 * Check if a given object implements the CreatePaymentMethodRequest interface.
 */
export function instanceOfCreatePaymentMethodRequest(value: object): value is CreatePaymentMethodRequest {
    if ((!('_configuration' in (value as Record<string, any>)) && !('configuration' in (value as Record<string, any>))) || ((value as Record<string, any>)['_configuration'] === undefined && (value as Record<string, any>)['configuration'] === undefined)) return false;
    if (!('paymentMethod' in value) || value['paymentMethod'] === undefined) return false;
    if (!('paymentMethodCategory' in value) || value['paymentMethodCategory'] === undefined) return false;
    if (!('paymentProvider' in value) || value['paymentProvider'] === undefined) return false;
    if (!('payoutSource' in value) || value['payoutSource'] === undefined) return false;
    return true;
}

export function CreatePaymentMethodRequestFromJSON(json: any): CreatePaymentMethodRequest {
    return CreatePaymentMethodRequestFromJSONTyped(json, false);
}

export function CreatePaymentMethodRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreatePaymentMethodRequest {
    if (json == null) {
        return json;
    }
    return {
        
        '_configuration': PaymentMethodConfigurationFromJSON(json['configuration']),
        'paymentMethod': json['paymentMethod'],
        'paymentMethodCategory': PaymentMethodCategoryFromJSON(json['paymentMethodCategory']),
        'paymentProvider': PaymentProviderFromJSON(json['paymentProvider']),
        'payoutSource': PayoutSourceFromJSON(json['payoutSource']),
    };
}

export function CreatePaymentMethodRequestToJSON(json: any): CreatePaymentMethodRequest {
    return CreatePaymentMethodRequestToJSONTyped(json, false);
}

export function CreatePaymentMethodRequestToJSONTyped(value?: CreatePaymentMethodRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'configuration': PaymentMethodConfigurationToJSON(value['_configuration']),
        'paymentMethod': value['paymentMethod'],
        'paymentMethodCategory': PaymentMethodCategoryToJSON(value['paymentMethodCategory']),
        'paymentProvider': PaymentProviderToJSON(value['paymentProvider']),
        'payoutSource': PayoutSourceToJSON(value['payoutSource']),
    };
}

